import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-711d4522"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Loading map & stacking gems...")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HamburgerMenu = _resolveComponent("HamburgerMenu")!
  const _component_gem_map = _resolveComponent("gem-map")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_HamburgerMenu, {
      ref: "hamburgerMenu",
      requestCount: _ctx.pendingFriendRequestCount
    }, null, 8, ["requestCount"]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createVNode(_component_gem_map, { gems: _ctx.gems }, null, 8, ["gems"])
          ])
        ])
      ]),
      fallback: _withCtx(() => [
        _createVNode(_component_van_row, {
          class: "loading-container",
          justify: "center",
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Loading, {
              class: "loading",
              size: "36px"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }))
  ]))
}